import { Effect } from "effect";
import { getPublicClient } from "./web/public-client";
import { runPublicCredentials } from "./invitations";

// A refresh that never answers would leave the request that needed the token,
// and every caller queued behind it, waiting forever. Past this it fails like
// any other refresh the server could not answer: the session is kept and the
// caller can retry.
export const REFRESH_TIMEOUT_MS = 30_000;

export const refreshToken = async (refresh_token: string) => {
  const client = await getPublicClient();
  const { data } = await runPublicCredentials(
    client.sessionTokens.refresh({ payload: { refresh_token } }).pipe(
      Effect.timeoutFail({
        duration: REFRESH_TIMEOUT_MS,
        onTimeout: () => new Error("Token refresh timed out"),
      }),
    ),
  );
  return data;
};
